module.exports = __webpack_public_path__ + "img/img14.431ff1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img14.png
// module id = 169
// module chunks = 0